import { render, staticRenderFns } from "./phone-call.vue?vue&type=template&id=125841ff&scoped=true&"
import script from "./phone-call.vue?vue&type=script&lang=js&"
export * from "./phone-call.vue?vue&type=script&lang=js&"
import style0 from "./phone-call.vue?vue&type=style&index=0&id=125841ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125841ff",
  null
  
)

export default component.exports